import { render, staticRenderFns } from "./SearchSimple.vue?vue&type=template&id=61dfccc2&"
import script from "./SearchSimple.vue?vue&type=script&lang=js&"
export * from "./SearchSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports